// Centralized data for the Valora360 LITE module (mock placeholders).

export const V360_STAGES = [
  { id: "E1", num: 1, key: "perfil",       label: "Perfil",              desc: "Contexto da empresa" },
  { id: "E2", num: 2, key: "volumes",      label: "Volumes",             desc: "Volumetria e risco" },
  { id: "E3", num: 3, key: "diretivas",    label: "Diretivas",           desc: "Descreva abaixo quais as principais intenções & alvos para a empresa no curto, médio e longo prazos" },
  { id: "E4", num: 4, key: "processos",    label: "Processos",           desc: "Maturidade 1-5 por frente" },
  { id: "E5", num: 5, key: "kpis",         label: "KPIs",                desc: "KPIs com confiança" },
  { id: "E6", num: 6, key: "analise",      label: "Análise Integrada",   desc: "4 perspectivas IA" },
  { id: "E7", num: 7, key: "plano",        label: "Plano de Ação",       desc: "Recomendações priorizadas" },
];

export const FRENTES = [
  { id: "F01", nome: "Finanças",     dom: "FI", cor: "blue" },
  { id: "F02", nome: "Operações",    dom: "OP", cor: "amber" },
  { id: "F03", nome: "Mercado",      dom: "MK", cor: "green" },
  { id: "F04", nome: "Pessoas",      dom: "PE", cor: "violet" },
  { id: "F05", nome: "Gestão",       dom: "GE", cor: "slate" },
];

export const TOPICOS_F02 = [
  { id: "OP-01", statement: "Mapeamos os processos operacionais críticos do negócio." },
  { id: "OP-02", statement: "Padronizamos a execução das atividades operacionais." },
  { id: "OP-03", statement: "Medimos o desempenho operacional com indicadores." },
  { id: "OP-04", statement: "Identificamos e tratamos gargalos operacionais." },
  { id: "OP-05", statement: "Treinamos a equipe operacional regularmente." },
];

export const ESCALA = [
  { n: 1, label: "Não fazemos", desc: "Ausente" },
  { n: 2, label: "Fazemos quando possível", desc: "Reativo" },
  { n: 3, label: "Fazemos sempre, mas informalmente", desc: "Repetitivo" },
  { n: 4, label: "Fazemos com processo consistente", desc: "Disciplinado" },
  { n: 5, label: "Fazemos, planejamos e melhoramos", desc: "Estruturado" },
];

export const BENCHMARK = {
  setorMedio: 2.8,
  topQuartil: 4.1,
};

export const KPIS_FINANCEIROS = [
  { code: "FI01", nome: "Faturamento mensal",       unidade: "R$",   descricao: "Receita bruta gerada pelas operações no mês de referência.",                      formula: "Σ (preço × quantidade vendida) no mês" },
  { code: "FI02", nome: "Margem de contribuição",   unidade: "%",    descricao: "Quanto de cada real vendido sobra após custos variáveis.",                          formula: "(Receita − Custos variáveis) / Receita × 100" },
  { code: "FI03", nome: "Lucro líquido",            unidade: "%",    descricao: "Resultado da empresa após todos os custos, despesas e impostos.",                  formula: "(Receita total − Custos totais − Despesas − Impostos) / Receita × 100" },
  { code: "FI04", nome: "Caixa disponível",         unidade: "dias", descricao: "Quantos dias de operação o caixa atual sustenta sem nova entrada.",                formula: "Saldo de caixa / (Despesas mensais ÷ 30)" },
  { code: "FI05", nome: "Inadimplência",            unidade: "%",    descricao: "Percentual de vendas a prazo não recebidas no vencimento.",                         formula: "Valores vencidos não pagos / Total a receber × 100" },
];

export const MOCK_PERFIL = {
  empresa: "Restaurante São Paulo",
  setor: "Alimentação",
  porte: "ME · Pequena Empresa",
  estagio: "Crescimento",
  regiao: "São Paulo / SP",
  produtos: "Almoço executivo, marmitas e delivery",
  publico: "Trabalhadores e famílias do bairro",
  diferencial: "Comida caseira, ambiente familiar, preço justo",
};
